import { useTranslation } from 'react-i18next';
import { ConfirmationMessageWithAction } from './ConfirmationMessageWithAction';
import imgEmailConfirmed from '../../assets/images/auth/email-confirmed.svg';
import imgErrorOccurred from '../../assets/images/auth/error.svg';
import { Links } from 'shared/infrastructure/Links';
import { Auth } from 'shared';
import {
  extractErrorMessageKeysFromHttpResponseException,
  localizeErrors,
} from 'shared/utils/response-error-handler';
import { LoginPageContainer } from 'auth/LoginPageContainer';
import LoginStyles from '../Login.module.scss';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

export const EmailChangedConfirmationPage = () => {
  const { userId, email, code } = useParams<{ userId: string; email: string; code: string }>();
  const { t } = useTranslation();
  const [errors, setErrors] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Auth.authService()
      .confirmChangeEmail(userId, email, code)
      .catch(e => {
        setErrors(extractErrorMessageKeysFromHttpResponseException(e));
      })
      .finally(() => setIsLoading(false));
  }, []);

  console.log(errors);
  return (
    <LoginPageContainer additionalClass={LoginStyles.confirmationPage} isLoading={isLoading}>
      {errors.length > 0 ? (
        <ConfirmationMessageWithAction
          image={imgErrorOccurred}
          title={t('Error_General')}
          description={localizeErrors(errors)}
        />
      ) : (
        <ConfirmationMessageWithAction
          image={imgEmailConfirmed}
          title={t('ProfileScreen.Email.ChangeConfirmed_Title')}
          description={t('Login_EmailConfirmed_Description')}
        />
      )}
    </LoginPageContainer>
  );
};
